import type { JSONContent } from '@tiptap/core';
import { useEffect, useMemo } from 'react';
import PdkEditorContent from './pdk-editor-content';
import { usePaddockEditor } from './use-paddock-editor';

const MessageTipTap = ({ content }: { content: JSONContent }) => {
  const initialContent = useMemo(() => {
    try {
      // DEV NOTE: comments and replies are stringified json
      // thus we need to parse it
      return content;
    } catch (error) {
      console.error('Error parsing initialContent', error);
      return '';
    }
  }, [content]);

  const { editor } = usePaddockEditor({
    initialContent,
    editable: false,
  });

  // DEV NOTE: this updates the UI when comments/replies are edited
  useEffect(() => {
    if (editor && !editor.isDestroyed) {
      editor.commands.setContent(content);
    }
  }, [editor, content]);

  return <PdkEditorContent editor={editor} readOnly />;
};

export default MessageTipTap;
